import React from 'react';

interface SettingsToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Required for screen readers — the row's title text is a good default. */
  ariaLabel: string;
  disabled?: boolean;
}

export const SettingsToggle: React.FC<SettingsToggleProps> = ({
  checked,
  onChange,
  ariaLabel,
  disabled,
}) => (
  <label className={`kx-settings-toggle ${disabled ? 'kx-settings-toggle--disabled' : ''}`.trim()}>
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      aria-label={ariaLabel}
      disabled={disabled}
    />
    <span className="kx-settings-toggle__slider" />
  </label>
);

export default SettingsToggle;
